import type {
  DataFetchParams,
  DataFetchResponse,
  FilterOptionsParams,
  DynamicFilterOptionsPage,
} from '@/components/DataTable';
import {
  listInstalledAiToolsDataTable,
  getInstalledAiToolsFilterOptions,
} from '@kirin/api-client/api/shadow-ai';
import type {
  InstalledToolListItem,
  InstalledToolsFilterOptionField,
  InstalledToolsSortField,
} from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { apiClient } from '@/lib/api-client';

export async function fetchInstalledAiTools(
  organizationId: string,
  params: DataFetchParams,
  signal?: AbortSignal,
  scopeUserId?: string
): Promise<DataFetchResponse<InstalledToolListItem>> {
  const sortField = params.sort?.field as InstalledToolsSortField | undefined;
  const response = await listInstalledAiToolsDataTable(
    apiClient,
    organizationId,
    {
      page: params.pagination.pageIndex + 1,
      limit: params.pagination.pageSize,
      filters: params.filters,
      sortBy: sortField,
      sortOrder: params.sort?.order,
      search: params.search,
      knownTotal: params.knownTotal,
      scopeUserId,
    },
    { signal }
  );

  return {
    data: response.data,
    pagination: response.pagination,
    meta: {
      activeFilters: response.meta?.activeFilters ?? [],
      search: response.meta?.search,
    },
  };
}

export async function fetchInstalledAiToolsFilterOptions(
  organizationId: string,
  field: InstalledToolsFilterOptionField,
  params: FilterOptionsParams,
  scopeUserId?: string
): Promise<DynamicFilterOptionsPage> {
  const response = await getInstalledAiToolsFilterOptions(
    apiClient,
    organizationId,
    {
      field,
      search: params.search,
      limit: params.limit,
      offset: params.offset,
      scopeUserId,
    }
  );

  return {
    options: response.options,
    total: response.pagination.total,
    nextOffset: response.pagination.nextOffset ?? null,
    hasMore: response.pagination.hasMore,
  };
}
